import { useMsal } from '@azure/msal-react';

/**
 * Returns displayName, email, and initials from the active MSAL account.
 */
export default function useUser() {
  const { accounts } = useMsal();
  const user = accounts[0] || {};
  const displayName = user.name || 'Unknown User';
  const email = user.username || '';
  const initials = displayName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return { displayName, email, initials };
}
